import { useState } from 'react';
import { BASE_URL } from '../utility/constants';
import { axiosInstance } from '../services/axiosConfig';

const useFormLibraryClientAccess = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [response, setResponse] = useState(null);

  const getClientAccess = async ({ form_library_id }) => {
    setLoading(true);
    setError(null);
    try {
      const res = await axiosInstance.get(`${BASE_URL}v1/form-library/${form_library_id}/client-access`);
      console.log(res.data);
      setResponse(res.data);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  const addClientAccess = async ({ form_library_id, client_id }) => {
    setLoading(true);
    setError(null);
    try {
      const res = await axiosInstance.post(
        `${BASE_URL}v1/form-library/${form_library_id}/client-access`,
        { form_library_id, client_id } // send both as required
      );
      setResponse(res.data);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  const removeClientAccess = async ({ form_library_id, client_id }) => {
    setLoading(true);
    setError(null);
    try {
      const res = await axiosInstance.delete(
        `${BASE_URL}v1/form-library/${form_library_id}/client-access/${client_id}`
      );
      setResponse(res.data);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  return { loading, error, response, getClientAccess, addClientAccess, removeClientAccess };
};

export default useFormLibraryClientAccess; 